module.exports = __webpack_public_path__ + "img/blog2.c8369438.png";